// services/CommentService.js

import API from "./api";


class CommentService {
  // Get all comments for a ticket
  async getTicketComments(ticketId) {
    const response = await API.get(`/api/comment/ticket/${ticketId}`);
    return response.data;
  }
  
  // Get comment by ID
  async getCommentById(commentId) {
    const response = await API.get(`/api/comment/${commentId}`);
    return response.data;
  }
  
  // Create a new comment
  async createComment(commentData, files = []) {
    const formData = new FormData();
    
    // Add comment text and ticket ID
    formData.append('text', commentData.text);
    formData.append('ticketId', commentData.ticketId);
    
    // Add any files
    files.forEach(file => {
      formData.append('files', file);
    });
    
    const response = await API.post('/api/comment', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  }
  
  // Update an existing comment
  async updateComment(commentId, commentData, files = []) {
    const formData = new FormData();
    
    // Add comment text
    formData.append('text', commentData.text);
    
    // Add any new files
    files.forEach(file => {
      formData.append('files', file);
    });
    
    const response = await API.put(`/api/comment/${commentId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  }
  
  // Delete a comment
  async deleteComment(commentId) {
    const response = await API.delete(`/api/comment/${commentId}`);
    return response.data;
  }
}

export default new CommentService();